import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';

const Subcategory = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [categories,setCategories]=useState([]);
  const [categoriesl,setCategoriesl]=useState([]);
  
  const [handleedit,seteditData]=useState({
    id:null,
    name:'',
    category_id:''
  })

  const [showeditmodal,setshoweditmodal]=useState(false); 

  const [formData, setFormData] = useState({
    name: '',
    category:'',
    media:''
  });
  
   const fetchcategories=async()=>{
    try{
     const res=await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/category');
     setCategories(res.data);
    }catch(e){
      setError(e.response?.data?.message || 'Failed to fetch categories');
    }
  }

  const fetchcategoriess=async()=>{
    try{
     const res=await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/subcategory');
     console.log(res.data);
     setCategoriesl(res.data);
    }catch(e){
      setError(e.response?.data?.message || 'Failed to fetch subcategories');
    }
  }

  
  useEffect(() => {
    fetchcategories();
    fetchcategoriess();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOpenModal = () => {
    setFormData({ name: '', category: '', media: '' });
    setShowModal(true);
    setError('');
  };

  const handlesave = async () => {
    setLoading(true);
    setError('');
      const data=new FormData();
      data.append('name',formData.name);
      data.append('category',formData.category);
      data.append('media',formData.media);
    try {
   await axios.post('https://api.squareandangle.pranatigroup.in/api/admin/subcategory',data, {
      headers:{
        "Content-Type":"multipart/form-data"
      },
      });
      setShowModal(false);
      fetchcategories();
      fetchcategoriess();
    } catch (e) {
      setError(e.response?.data?.message || 'Save failed');
    } finally {
      setLoading(false);
    }
  };


   const handleeditin=(item)=>{
    seteditData({
      id:item.id,
      name:item.subcategory,
      category_id:item.category_id,
      media:item.images
    })
    setshoweditmodal(true);
   }
 
   const handledelete=async(id)=>{
     setLoading(true);
    try{
         await axios.delete(`https://api.squareandangle.pranatigroup.in/api/admin/subcategory/${id}`);
      fetchcategoriess();
    }catch(e){
        setError(e.response?.data?.message || 'Delete failed');
    }finally{
      setLoading(false);
    }
   }


   const handleupdatecat=async()=>{
     setLoading(true);
     setError('');
    try{
      const data=new FormData();
      data.append('name',handleedit.name);
      data.append('media',handleedit.media);
      data.append('category_id',handleedit.category_id);
    
       await axios.put(`https://api.squareandangle.pranatigroup.in/api/admin/subcategory/${handleedit.id}`,data,{
        headers:{"Content-Type":"multipart/form-data"}
      }
      );
      fetchcategoriess();
      setshoweditmodal(false);
      setLoading(false);
    }catch(e){
      setError(e.response?.data?.message || 'Update failed');
      setLoading(false);
      setshoweditmodal(false);
    }
   }

  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };
  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="container-fluid" style={isMobile ? {} : stylesD}>
        <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">
          <h3 className="m-0">Subcategories</h3>
          <button className="btn btn-primary" onClick={handleOpenModal}>+ Add New</button>
        </div>
        <div className="table-responsive w-100 p-0">
          <table className="table table-bordered table-striped bg-white w-100 m-0">
            <thead className="thead-dark">
              <tr>
                <th>Serial No</th>
                <th>Category</th>
                <th>Subcategory Name</th>
                <th>Images</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
            
                {
                categoriesl.length>0 ?(
                
                categoriesl.map((item, index) => (
                <tr key={item.id}>
               
                  <td>{index +1}</td>
                  <td>{item.category_name}</td>
                  <td>{item.subcategory}</td>
                   <td><img src={uploadUrl(item.images)} alt="pranati website" width="100"/></td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-outline-primary mr-2" onClick={()=>handleeditin(item)}>Edit</button>
                    <button className="btn btn-sm btn-outline-danger" onClick={()=>handledelete(item.id)}>Delete</button>
                  </td>
                </tr>
              ))
                ):(
               <tr>

                <td colSpan="4" className="text-center text-muted">
                  No Subcategories Found
                </td>
               </tr>

                )}
            </tbody>

            
           
          </table>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Subcategory</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Subcategory Name"
                  value={formData.name} 
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />

                <select className="form-control mb-2" value={formData.category} onChange={(e)=>setFormData({...formData, category: e.target.value})}>
                    <option value="">Select Category</option>
                    {categories.map((item)=>(
                       
                        <option key={item.id} value={item.id}>{item.category}</option>
                    ))}
                </select>

                 <input 
                  type="file"
                  className="form-control mb-2"
                  onChange={(e) => setFormData({ ...formData, media: e.target.files[0] })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlesave} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {showeditmodal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Subcategory</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setshoweditmodal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Subcategory Name"
                  value={handleedit.name} 
                  onChange={(e) => seteditData({ ...handleedit, name: e.target.value })}
                />
                <select className="form-control mb-2" value={handleedit.category_id} onChange={(e)=>seteditData({...handleedit, category_id: e.target.value})}>
                    <option value="">Select Category</option>
                     {categories.map((item)=>(
                       
                        <option key={item.id} value={item.id} selected={categories.id===handleedit.category_id}>{item.category}</option>
                    ))}
                </select>

                 <input 
                  type="file"
                  className="form-control mb-2"
                  onChange={(e) => seteditData({ ...handleedit, media: e.target.files[0] })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setshoweditmodal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleupdatecat} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Subcategory;

